import { CrownCircleOutlineIcon } from './CrownCircleOutlineIcon';

/**
 * author: Michael Irigoyen
 * id A25B1BFF-7DEC-4A6C-B91A-3B2A149997F1
 * name crown-circle-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/crown-circle-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const CheckersOutlineIcon = CrownCircleOutlineIcon;
export default CheckersOutlineIcon